import { Component, OnInit, HostBinding, ViewChild, ElementRef } from '@angular/core';
import { Endpoint, HelpIndex } from '../../../../models/enums';
import { GenericColDef, CellTemplateType, AlignDirection, FilterTemplateType, SortByFilter, GridContext } from '../../../../models/grid-context';
import { GenericGridComponent } from '../../../generic-grid/generic-grid.component';
import { ContextMenuOption } from '../../../../models/context-menu-option';
import { RestService } from '../../../../services/rest/rest.service';
import { CommonService } from '../../../../services/common/common.service';

@Component({
	standalone: false,
	selector: 'res-deleted-projects-settings',
	templateUrl: './deleted-projects-settings.component.html',
	styleUrls: ['./deleted-projects-settings.component.scss']
})
export class DeletedProjectsSettingsComponent {
	@HostBinding('class') classes = 'maximized-component';
	@ViewChild(GenericGridComponent, { static: true }) genericGrid: GenericGridComponent;
	@ViewChild('downloadLink', { read: ElementRef, static: true }) downloadLink: ElementRef;

	// grid info
	gridName = 'Deleted Projects';
	automationId = 'deleted-projects-settings';
	helpIndex = HelpIndex.sys_deleted_projects_dlg;
	gridIsBusy = false;
	gridBusyMessage = 'Loading Deleted Projects ...';

	columnDefs = new Array<GenericColDef>(
		{
			headerName: 'Project Name',
			field: 'projectName',
			automationId: 'project-name-column',
			lockVisible: true,
			minWidth: 60,
			width: 260,
			filterType: FilterTemplateType.freeform,
			serviceTierFilter: true,
			filterAttributeName: 'PROJECT_NAME'
		},
		{
			headerName: 'Project Description',
			field: 'description',
			automationId: 'project-desc-column',
			minWidth: 60,
			width: 510,
			filterType: FilterTemplateType.freeform,
			serviceTierFilter: true,
			filterAttributeName: 'DESCRIPTION'
		},
		{
			headerName: 'Organization',
			field: 'orgName',
			automationId: 'organization-column',
			minWidth: 60,
			filterType: FilterTemplateType.comboBox,
			filterAttributeName: 'ORG',
			serviceTierFilter: true
		},
		{
			headerName: 'Date Created',
			automationId: 'date-created-column',
			cellAlignDirection: AlignDirection.right,
			field: 'dateCreated',
			width: 145,
			minWidth: 145,
			filterType: FilterTemplateType.date,
			serviceTierFilter: true,
			filterAttributeName: "DATE_CREATED",
			cellTemplateType: CellTemplateType.date,
			suppressMovable: true,
			headerAlignDirection: AlignDirection.right
		},
		{
			headerName: 'Date Deleted',
			automationId: 'date-deleted-column',
			cellAlignDirection: AlignDirection.right,
			field: 'dateDeleted',
			width: 145,
			minWidth: 145,
			filterType: FilterTemplateType.date,
			serviceTierFilter: true,
			filterAttributeName: 'DATE_DELETED',
			cellTemplateType: CellTemplateType.date,
			suppressMovable: true,
			headerAlignDirection: AlignDirection.right,
			defaultSortBy: SortByFilter.NAME
		},
		{
			headerName: 'Deleted By',
			field: 'userName',
			automationId: 'deleted-by-column',
			minWidth: 60,
			width: 190
		},
		{
			automationId: this.automationId,
			cellTemplateType: CellTemplateType.contextMenu,
			minWidth: 30, maxWidth: 30, width: 30,
			suppressSizeToFit: true
		},
	);

	contextMenuOptions = [
		new ContextMenuOption({
			name: 'Download Project Audit Log', iconClass: 'fa-download', iconColor: 'color-blue-01', automationId: 'projects-list-delete-project',
			click: (item) => this.downloadProjectAuditLog(item)
		})
	];

	gridContext = new GridContext({ sortBy: SortByFilter.NAME, sortAscending: false, sortEnabled: false });

	requestInfo = {
		endpoint: Endpoint.realmManager_listDeletedProjects,
		responseName: 'deletedProjects',
		data: {
			count: 50,
			filters: [],
			startIndex: 0,
			sortAscending: false,
			systemScope: true
		}
	};

	constructor(private restService: RestService, private commonService: CommonService) {
		this.restService.post(Endpoint.realmManager_listOrganizations, { count: 0, startIndex: 0, filters: [], systemScope: true }).then(response => {
			const orgNameColDef = this.columnDefs.find(f => f.field === 'orgName');
			if (response?.organizations && orgNameColDef) {
				orgNameColDef.filterItems = response.organizations.map(q => q.name).sort();
				if (this.genericGrid) {
					this.genericGrid.setColumnDefs(this.columnDefs);
					this.genericGrid.refreshColumns();
				}
			}
		});
	}

	downloadProjectAuditLog(item) {
		this.restService.post(Endpoint.realmManager_getDeletedProjectAuditLogUrl, {
			fileName: item.projectName + '_auditlog',
			projectHandle: item.projectId,
			systemScope: true
		}).then(response => {
			if (response?.auditLogsUrl) {
				this.commonService.unzipFile(response.auditLogsUrl, this.downloadLink.nativeElement, item.projectName + '_auditlog');
			}
		});
	}
}
